var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTargetLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9301 2.00036C17.431 1.95375 21.953 6.38249 21.9996 11.9301C22.0463 17.4777 17.5709 21.953 12.0699 21.9996C6.52234 22.0463 2.00036 17.6175 2.00036 12.0699C1.95375 6.52234 6.38249 2.04698 11.9301 2.00036ZM11.8835 5.35689C8.20061 5.4035 5.26365 8.38708 5.26365 12.0699C5.35689 15.7062 8.38708 18.6897 12.0233 18.6431C15.7062 18.5965 18.6431 15.6129 18.5965 11.9301C18.5499 8.24722 15.5663 5.31027 11.8835 5.35689ZM11.9301 8.48031C13.8414 8.4337 15.4265 9.9721 15.4265 11.8835C15.4731 13.7948 13.9347 15.3798 12.0233 15.3798C10.112 15.3798 8.57355 13.888 8.48032 11.9767C8.48032 10.0653 10.0187 8.48031 11.9301 8.48031Z",
  fill: "black"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTargetLogo);
export default ForwardRef;